import { render, staticRenderFns } from "./detail_config_dataset_list.vue?vue&type=template&id=39e3f05c"
import script from "./detail_config_dataset_list.vue?vue&type=script&lang=js"
export * from "./detail_config_dataset_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e3f05c')) {
      api.createRecord('39e3f05c', component.options)
    } else {
      api.reload('39e3f05c', component.options)
    }
    module.hot.accept("./detail_config_dataset_list.vue?vue&type=template&id=39e3f05c", function () {
      api.rerender('39e3f05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/detail_config_dataset_list.vue"
export default component.exports